import { render, staticRenderFns } from "./FormularioBecasContIngresosEgresos.vue?vue&type=template&id=a7b3dc28&"
import script from "./FormularioBecasContIngresosEgresos.vue?vue&type=script&lang=js&"
export * from "./FormularioBecasContIngresosEgresos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSnackbar})
